module.exports = __webpack_public_path__ + "static/services-e803563c925d3ff7234b0392ef655522.svg";